
<template>
  <div style="position:relative;">
    <div class="w1200 newsBox">
      <div class="leftBox">
        <div class="fenlei">
          <div class="columnBoxInnner">
            <div class="columnBoxInnnerList">
              <div v-for="(item,index) in arrs" :key="index" :class="currrentindex==index?'activename':'column_a'" @click="changeNowColumn(item.value,index)">
                <span class="nameshow">{{ item.name }}</span><span v-show="index<arrs.length-1" class="a_span">/</span>
              </div>
            </div>
          </div>
        </div>
        <div style="min-height: 80vh">
          <!--<div>{{columnlist}}</div>-->
          <!-- 内容列表 -->
          <div class="crumbs">
            <span class="el-icon-location" />
            <span class="sname" @click="gohome">首页</span>
            <span>/搜索：<span style="color: #ed4040"><span v-if="searchkey">"{{ searchkey }}"</span></span></span>
            <span class="first_span">共找到</span>
            <span class="marker">{{ currentCount }}</span>
            <span>个结果，</span>
            <span class="searchtext" @click="gosearchgen">使用根籍搜索 <span v-if="searchkey">"{{ searchkey }}"</span>检索更多结果>></span>
          </div>
          <Centerlisthome :columnlist="currentData" />
          <div v-if="loadAll" class="atfoot loadMore">
            已经到底部了
          </div>
          <div v-else class="loadMore" @click="addMore">
            加载更多>>
          </div>
        </div>
      </div>
      <div class="rightBox">
        <Rightlist />
      </div>
    </div>
    <!--<div class="topshow">-->
    <!--<div style="width: 1200px;margin: 0 auto;">-->
    <!--<div class="imgbox_top">-->
    <!--<img :src="searchlogo" alt="">-->
    <!--</div>-->
    <!--<div class="searchbox">-->
    <!--<input v-model="keys" type="text" class="keys_input" placeholder="输入关键字搜索"><div class="btn" @click="goSearch">-->
    <!--一键搜索-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
  </div>
</template>
<script>
import Rightlist from '@/components/commonRightList'
import Centerlisthome from '@/components/centerlist_specTopic_detial/index.vue'
import { getContextSS } from '@/api/api.js'
export default {
  inject: ['reload'],
  components: { Rightlist, Centerlisthome },
  head() {
    // var listObj = this.$store.state.hotList_home
    var titles = ''
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    if (this.searchkey) {
      titles = this.searchkey
    }
    return {
      title: '搜索：' + titles + '-彭祖世家网',
      mateDesc: '《彭祖世家总谱-事典》门户网站Pengzushijia.COM ，系彭祖世家文化发展有限公司与武汉聚脉网络科技有限公司合作，基于聚脉网络旗下国家发明专利技术产品“大谱师-互联网家谱协作编纂平台”进行品牌定制，专属服务全球彭氏族群编纂《彭祖世家总谱-事典》总谱、家族谱、家庭谱的互联网家谱协作编纂平台。',
      keys: '《彭祖世家总谱-事典》门户网站Pengzushijia.COM ，彭祖,彭城,彭氏,彭姓,彭氏家谱,彭氏宗谱,彭氏族谱,彭祖世家,彭氏修谱,门户网站'
    }
  },
  data() {
    return {
      keys: '',
      searchlogo: require('@/static/sarch_logo.png'),
      currrentindex: 0,
      loadAll: false,
      arrs: [
        { name: '全部', value: '' },
        { name: '资讯', value: '7' },
        { name: '图集', value: '10' },
        { name: '视频', value: '8' },
        { name: '文库', value: '9' },
        { name: '谱书', value: '1' },
        { name: '谱文', value: '2' },
        { name: '谱系', value: '3' },
        { name: '人物', value: '4' },
        { name: '书页', value: '5' },
        { name: '页图', value: '6' }
      ],
      currentData: '',
      currentPage: 1,
      page: 1,
      currentType: '',
      currentCount: ''
    }
  },
  computed: {
    searchkey() {
      return this.$route.query.searchName
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === 'search') {
        if (to.query.searchName) {
          var obj = {}
          obj.str = to.query.searchName
          obj.index = '1'
          obj.size = '9'
          obj.type = this.currentType
          getContextSS(obj).then(res => {
            this.page = res.data.page
            if (this.page == 0) {
              this.page = 1
            }
            this.currentData = res.data.listMapData
            this.currentCount = res.data.count
            var str = /^http/
            for (var i = 0; i < this.currentData; i++) {
              if (!str.test(this.currentData[i].CONTENT_PHOTO) && this.currentData[i].CONTENT_PHOTO) {
                this.currentData[i].CONTENT_PHOTO_NAME = this.currentData[i].CONTENT_PHOTO
              }
            }
            if (this.currentPage * 1 >= this.page * 1) {
              this.loadAll = true
            }
          })
        }
      }
    }
  },
  mounted() {
    this.keys = this.$route.query.searchName
    var obj = {}
    obj.str = this.$route.query.searchName
    obj.index = '1'
    obj.size = '9'
    obj.type = this.currentType
    getContextSS(obj).then(res => {
      this.page = res.data.page
      if (this.page == 0) {
        this.page = 1
      }
      this.currentData = res.data.listMapData
      this.currentCount = res.data.count
      var str = /^http/
      for (var i = 0; i < this.currentData; i++) {
        if (!str.test(this.currentData[i].CONTENT_PHOTO) && this.currentData[i].CONTENT_PHOTO) {
          this.currentData[i].CONTENT_PHOTO_NAME = this.currentData[i].CONTENT_PHOTO
        }
      }
      if (this.currentPage * 1 >= this.page * 1) {
        this.loadAll = true
      }
    })
  },

  methods: {
    fn: function() {
      window.scrollTo(0, 0)
    },
    changeNowColumn: function(type, index) {
      this.loadAll = false
      this.currentPage = 1
      this.currentType = type
      var obj = {}
      obj.index = '1'
      obj.size = '9'
      obj.str = this.$route.query.searchName
      this.currrentindex = index
      obj.type = type
      getContextSS(obj).then(res => {
        this.page = res.data.page
        if (this.page == 0) {
          this.page = 1
        }
        this.currentData = res.data.listMapData
        this.currentCount = res.data.count
        var str = /^http/
        for (var i = 0; i < this.currentData; i++) {
          if (!str.test(this.currentData[i].CONTENT_PHOTO) && this.currentData[i].CONTENT_PHOTO) {
            this.currentData[i].CONTENT_PHOTO_NAME = this.currentData[i].CONTENT_PHOTO
          }
        }
        if (this.currentPage * 1 >= this.page * 1) {
          this.loadAll = true
        }
      })
    },
    addMore: function() {
      this.currentPage = this.currentPage * 1 + 1
      var obj = {}
      obj.index = this.currentPage
      obj.str = this.$route.query.searchName
      obj.size = '9'
      obj.type = this.currentType
      getContextSS(obj).then(res => {
        var newdata = res.data.listMapData
        var str = /^http/
        for (var i = 0; i < newdata; i++) {
          if (!str.test(newdata[i].CONTENT_PHOTO) && newdata[i].CONTENT_PHOTO) {
            newdata[i].CONTENT_PHOTO_NAME = newdata[i].CONTENT_PHOTO
          }
        }
        this.currentData = this.currentData.concat(newdata)
      })
      if (this.currentPage * 1 >= this.page * 1) {
        this.loadAll = true
      }
    },
    gohome: function() {
      this.$router.push({ path: '/home' })
    },
    goSearch: function() {
      if (this.keys) {
        this.$router.replace({ path: '/search', name: 'search', query: { searchName: this.keys }})
        this.searchKey = this.key
        this.loadAll = false
        this.currentPage = 1
        var obj = {}
        obj.index = '1'
        obj.size = '9'
        obj.str = this.keys
        obj.type = this.currentType
        getContextSS(obj).then(res => {
          this.page = res.data.page
          if (this.page == 0) {
            this.page = 1
          }
          this.currentData = res.data.listMapData
          this.currentCount = res.data.count
          var str = /^http/
          for (var i = 0; i < this.currentData; i++) {
            if (!str.test(this.currentData[i].CONTENT_PHOTO) && this.currentData[i].CONTENT_PHOTO) {
              this.currentData[i].CONTENT_PHOTO_NAME = this.currentData[i].CONTENT_PHOTO
            }
          }
          if (this.currentPage * 1 >= this.page * 1) {
            this.loadAll = true
          }
        })
      } else {
        this.$message({
          message: '请输入关键字',
          type: 'warning',
          duration: 1500
        })
      }
    },
    gosearchgen() {
      const { href } = this.$router.resolve({
        path: '/allDataSearch',
        name: 'asv',
        query: {
          'searchName': this.$route.query.searchName
        }
      })
      window.open(href, '_blank')
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .searchtext{
    color: #ed4040;
    cursor: pointer;
  }
    .first_span{
        margin-left: 40px;
    }
    .marker{
        color: #ed4040;
    }
  .topshow{
    width: 100%;
    height: 100px;
    background-color: #ffffff;
    padding-top: 40px;
    position: absolute;
    top: -140px;
    left: 0;
    z-index: 999;
    .imgbox_top{
      width: 221px;
      height: 56px;
      display:inline-block;
      vertical-align: top;
      margin-left: 200px;
      img{
        width: 221px;
        height: 56px;
      }
    }
    .searchbox {
      display: inline-block;
      overflow: hidden;
      /*float: right;*/
      margin-top: 10px;
      margin-left: 70px;
      vertical-align: top;
      span {
        display: inline-block;
        height: 36px;
        width: 98px;
        border: 1px solid #7e6b5a;
        vertical-align: top;
        text-align: center;
        line-height: 40px;
      }
      .keys_input {
        height: 36px;
        width: 313px;
        border-top: 1px solid #7e6b5a;
        border-bottom: 1px solid #7e6b5a;
        border-left: 1px solid #7e6b5a;
        padding-left: 5px;
        vertical-align: top;
        text-indent: 15px;
      }
      .btn {
        display: inline-block;
        background-color: #7e6b5a;
        color: #ffffff;
        line-height: 38px;
        height: 38px;
        text-align: center;
        width: 101px;
        cursor: pointer;
      }
    }
  }
  .sname{
    color: #ed4040;
    cursor: pointer;
  }
  .atfoot{
    cursor: auto;
  }
    .loadMore{
      text-align: center;
      height: 45px;
      line-height: 45px;
      font-size: 14px;
      color: #999999;
      background-color: #fff;
      border: 1px solid #e5e5e5;
      border-radius: 3px;
      cursor: pointer;
      display:inline-block;
      width: 100%;
      margin-top: 20px;
      transition: 0.5s;
      margin-bottom: 20px;
      &:hover{
        color: #ed4040;
        border: 1px solid #ed4040;
      }
    }
  .newsBox{
    background-color: #fafafa;
    overflow: hidden;
    position: relative;
  }
  .leftBox{
    width: 880px;
    margin-right: 20px;
    margin-top: 20px;
    float: left;
    .crumbs{
      line-height: 35px;
      /*border: 1px solid #e5e5e5;*/
      padding-left: 20px;
      color: #808080;
      background-color: #fff;
      font-size: 16px;
      span{
        font-size: 16px;
      }
      .gohome{
        cursor: pointer;
      }
    }
    .imgBox{
      margin-top: 20px;
      height: 300px;
      position: relative;
      background-color: #fff;
      img{
        width: 100%;
        height: 100%;
      }
      p{
        position: absolute;
        text-align: center;
        width: 880px;
        color:#ffffff;
      }
      .names{
        height: 40px;
        line-height: 40px;
        top: 130px;
        font-size: 28px;
      }
      .times{
        top: 170px;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
      }
    }
    .specialAbstract_box{
      background-color: #fff;
      overflow: hidden;
      .specialAbstract{
        margin:20px 30px;
        background-color: #fafafa;
        overflow: hidden;
        padding: 10px 25px;
        font-size: 12px;
        color: #4d4d4d;
      }
    }
    .fenlei{
      overflow: hidden;
      text-align: center;
      background-color: #fff;
      height: 60px;
      margin-bottom: 20px;
      line-height: 60px;
      .column_a{
        display: inline-block;
        cursor: pointer;
        font-size: 16px;
        .a_span{
          margin: 0 10px;
        }
        .nameshow{
          font-size: 16px;
          color: #333333;
          font-weight: 600;
          &:hover{
            color: #ed4040;
          }
        }
      }
      .activename{
        display: inline-block;
        cursor: pointer;
        .a_span{
          margin: 0 10px;
        }
        .nameshow{
          color: #ed4040;
          font-size: 16px;
          font-weight: 600;
        }

      }
    }

  }
  .rightBox{
    width: 300px;
    /*margin-left: 20px;*/
    margin-top: 20px;
    float: right;
    /*top: 0;*/
    /*right: 0;*/
    overflow: hidden;
  }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .leftBox{
      width: 100%;
      margin-top: 0;
      .crumbs{
        margin-bottom: 0;
      }
      .bannerBox{
        width: 100%;
        height: auto;
      }
      .fenlei{

      }
    }
    .rightBox{
      display: none;
    }
    .columnBoxInnner{
      width: 100%;
      overflow: hidden;
      padding-bottom: 20px;
      overflow-x: auto;
      .columnBoxInnnerList{
        /*margin-top: 10px;*/
        white-space: nowrap;
        padding: 0 20px;
      }
    }
  }
  .columnBoxInnnerList {
    /*margin-top: 10px;*/
  }
</style>
